import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getbloghome,
  postBlogForm,
  blogFileUploder,
  getBlogcategory,
  putBlogData,
  advanceSearchBlog,
  getBlogCategoryService,
  deleteBlogCategoryService,
  addBlogCategoryService,
} from "../../../../utils/services/blogMocktest/blog/blogService";
import BlogDeleteDilog from "../../../../components/blogsMore/BlogDeleteDilog";
import axiosInstance from "../../../../axios";

export const getBlog = createAsyncThunk("/blog/get", async (_, thunkAPI) => {
  const { page, limit, searchKey } = thunkAPI.getState().blog;

  // const blogname=thunkAPI.blogName ??"";

  const payload = {
    page: page + 1,
    limit: limit,
    searchName: searchKey,
  };

  const response = await getbloghome(payload);
  if (response?.error) {
    return thunkAPI.rejectWithValue(response?.error);
  }
  return response;
});

// export const getBlog = createAsyncThunk(
//   "/blog/get",
//   async ( thunkAPI) => {
//     const blogname=thunkAPI.blogName ??"";
//     const response = await getbloghome({blogname});
//     if (response?.error) {
//       return thunkAPI.rejectWithValue(response?.error);
//     }
//     return response;
//   }
// );

export const getblogpatch = createAsyncThunk("/blog/get", async (thunkAPI) => {
  console.log("blognaemmmmmm", thunkAPI);
  const id = thunkAPI;
  const response = await axiosInstance.get(`blogs/${id}`);
  console.log(response, "ckkkk");
  if (response?.error) {
    return thunkAPI.rejectWithValue(response?.error);
  }
  return response;
});
export const postBlog = createAsyncThunk(
  "/blog/post",
  async (payload, thunkAPI) => {
    const response = await postBlogForm(payload);
    console.log("blogname", response);
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);
export const fileUpload = createAsyncThunk(
  "/blog/file-upload",
  async (payload, thunkAPI) => {
    const response = await blogFileUploder(payload);
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);
export const blogcategory = createAsyncThunk(
  "/blog/category",
  async (thunkAPI) => {
    const response = await getBlogcategory();
    console.log(response, ">>?");
    if (response?.error) {
      return thunkAPI.rejectWithValue(response?.error);
    }
    return response;
  }
);

export const patchApiData = createAsyncThunk(
  "api/patchData",
  async ({ id, data }) => {
    try {
      const response = await axiosInstance.patch(`blogs/${id}`, data);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const advanceSearchget = createAsyncThunk(
  "api/advancesearch",
  async (thunkAPI) => {
    console.log(thunkAPI, "datasearch");
    const payload = { ...thunkAPI };
    console.log(payload, "searchoption");
    try {
      const response = await advanceSearchBlog(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// export const deleteblogdata = createAsyncThunk(
//   "/subadmin/delete",
//   async (payload, thunkAPI) => {
//     const response = await BlogDeleteDilog(payload);
//     console.log(response, "heheheh");
//     if (
//       response?.data?.statusCode === 200 ||
//       response?.data?.statusCode === 201
//     ) {
//       thunkAPI.dispatch(getBlog());
//     }
//     return response;
//   }
// );

export const getAllBlogCategory = createAsyncThunk(
  "/blogCategory/get",
  async (_, thunkAPI) => {
    const { searchKey } = thunkAPI.getState().category;
    const payload = {
      searchKey,
    };
    const response = await getBlogCategoryService(payload);
    return response;
  }
);

export const deleteBlogCategory = createAsyncThunk(
  "/blogCategory/delete",
  async (id, thunkAPI) => {
    const { isSuccess, message, error } = await deleteBlogCategoryService(id);

    if (error) {
      return thunkAPI.rejectWithValue(error);
    }
    thunkAPI.dispatch(getAllBlogCategory());
    return { isSuccess, message };
  }
);
